import * as React from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Backdrop,
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import { useEffect, useState } from "react";
import Parse from "../../API/ParseServer";
import styles from "./MemorabiliaAlbumTab.module.css";
import long from "../Assets/memorabilia/Long-Sleeve-examples.png";
import { Slide } from "react-slideshow-image";
import ClearIcon from "@mui/icons-material/Clear";
import Album from "../Album/Album";

const indicators = (index: any) => <li className={styles.indicator}></li>;
const properties = {
  prevArrow: <ArrowBackIosRoundedIcon className={styles.arrow} />,
  nextArrow: <ArrowForwardIosRoundedIcon className={styles.arrow} />,
};
interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",

    // padding: "12px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "black",
    Padding: "3px",
  },
  borderBottom: "2px solid #dad9da",
  boxSizing: "inherit",
  // "& .MuiTabs-indicator": {
  //   backgroundColor: "#1890ff",
  // },
  "& .MuiTabs-scroller": {
    overflow: "scroll !important",
    "&::-webkit-scrollbar": {
      display: "none !important",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(20),
  marginRight: theme.spacing(1),
  color: "gray",
  "&.Mui-selected": {
    color: "black",
    boxShadow: "0 4px #0a0a0a",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "black",
    boxShadow: "0 4px #0a0a0a",
  },
}));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box py={2}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// export default function CustomizedTabs();
const MemorabiliaAlbumTab: React.FC<{
  // description: string;
  // year: number;
  // subjects: string[];
  // styles: string[];
  // mediums: string[];
}> = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [selectedTopics, setSelectedTopics] = useState<any>([]);
  const [topics, setTopics] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = React.useState("");
  const [football, setFootball] = useState<any>();
  const [rugby, setRugby] = useState<any>();
  const [otherShirt, setOtherShirt] = useState<any>();
  const [otherSport, setOtherSport] = useState<any>();
  const [footballArray, setFootballArray] = useState<number[]>([]);
  const [rugbyArray, setRugbyArray] = useState<number[]>([]);
  const [otherShirtArray, setOtherShirtArray] = useState<number[]>([]);
  const [otherSportArray, setOtherSportArray] = useState<number[]>([]);
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (event: any) => {
    setModal(event.target.id);
  };
  useEffect(() => {
    const fetchAlbum = async () => {
      const query = new Parse.Query("Album");

      try {
        const results = await query.find();
        // setTopics(results);
        results.forEach((album: any) => {
          if (album.get("type") === "Football") {
            setFootball(album);
            for (let i = 1; i <= album.get("counter"); i++) {
              setFootballArray((cur: number[]) => {
                if (!cur.find((num: any) => num === i)) return [...cur, i];
                else return cur;
              });
            }
          } else if (album.get("type") === "Rugby") {
            setRugby(album);
            // console.log(album.get("counter"))
            for (let i = 1; i <= album.get("counter"); i++) {
              setRugbyArray((cur: number[]) => {
                if (!cur.find((num: any) => num === i)) return [...cur, i];
                else return cur;
              });
            }
          } else if (album.get("type") === "Other Shirts") {
            setOtherShirt(album);
            for (let i = 1; i <= album.get("counter"); i++) {
              setOtherShirtArray((cur: number[]) => {
                if (!cur.find((num: any) => num === i)) return [...cur, i];
                else return cur;
              });
            }
          } else  if (album.get("type") === "Other Sports") {
            setOtherSport(album);
            for (let i = 1; i <= album.get("counter"); i++) {
              setOtherSportArray((cur: number[]) => {
                if (!cur.find((num: any) => num === i)) return [...cur, i];
                else return cur;
              });
            }
          }
        });
        // console.log(results);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAlbum();
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
          sx={{ overflow: "scroll" }}
        >
          <StyledTab label="Football Shirts" {...a11yProps(0)} />
          <StyledTab label="Rugby Shirts" {...a11yProps(1)} />
          <StyledTab label="Other Shirts" {...a11yProps(2)} />
          <StyledTab label="Other Memorabilia" {...a11yProps(3)} />
        </StyledTabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        {football && <Album album={football} albumArray={footballArray} />}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        {rugby && <Album album={rugby} albumArray={rugbyArray} />}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        {otherShirt && <Album album={otherShirt} albumArray={otherShirtArray} />}
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        {otherSport && <Album album={otherSport} albumArray={otherSportArray} />}
      </CustomTabPanel>
    </Box>
  );
};
export default MemorabiliaAlbumTab;
